var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.label)?_c('label',{staticClass:"label",class:{'has-subtitle':_vm.sub}},[_vm._v("\n  "+_vm._s(_vm.label)+"\n  "),(_vm.sub)?[_c('br'),_c('small',[_vm._v(_vm._s(_vm.sub))])]:_vm._e()],2):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }